// Module
var code = "<template bindable=\"isMember, groupData\"> <require from=\"./view-header-member-directory\"></require> <view-header-member-directory group-data.bind=\"groupData\"></view-header-member-directory> </template> ";
// Exports
export default code;